import { createSelector } from 'reselect'

export const getLoadingBar = state => state.get('loadingBar')

export const isLoaded = createSelector(getLoadingBar, loadingBar => loadingBar && loadingBar.default > 0)
